<template>
  <div class="card">
    <div class="card-body">
      <div class="card-header card-header-divider">
        <div class="card-title">{{ route.params.id ? 'Редактирование' : 'Создание'}} подписки</div>
      </div>
      <div class="card-body" v-if='isLoaded'>
        <form
            action="#"
            class="subscription_form"
            @submit.prevent="saveSubscription"
            novalidate
        >
          <div class="form-group">
            <custom-input
              v-model="subscriptionForm.title"
              name="title"
              label="Название"
            />

            <custom-input
                v-model="subscriptionForm.description"
                name="description"
                label="Описание"
            />

            <custom-input
                v-model="subscriptionForm.price"
                type="number"
                name="price"
                :min="0"
                label="Цена"
            />

            <custom-input
                v-model="subscriptionForm.duration_months"
                name="duration_months"
                type="number"
                label="Срок действия (в месяцах)"
            />
            <custom-select-2
                v-model="subscriptionForm.update_period"
                name="update_period"
                label="Период обновления доступов"
                :options="updatePeriodOptions"
            />
            <div class="available_checkbox">
              <custom-checkbox
                  v-model="subscriptionForm.available"
                  :checked="subscriptionForm.available"
                  name="available"
                  label="Доступна к покупке"
              />
            </div>
            <div class="company_checkbox">
              <custom-checkbox
                  v-model="subscriptionForm.for_company"
                  :checked="subscriptionForm.for_company"
                  name="for_company"
                  label="Для компании"
              />
            </div>
            <div class="analytics_access">
              <p class="analytics_access__title">Доступ к аналитике</p>
              <custom-checkbox
                  v-for="option in analyticsAccessOptions"
                  :key="option.key"
                  v-model="subscriptionForm.analytics_access[option.key]"
                  :checked="subscriptionForm.analytics_access[option.key]"
                  :name="option.key"
                  :label="option.label"
              />
            </div>
          </div>

          <div class="products_header">
            <p class="card-title">
              Состав
            </p>
          </div>

          <div v-for="(entity, index) in products" :key="index">
            <custom-select-2
                label="Тип сущности"
                name="entity"
                v-model="entity.type"
                :options="types"
            />

            <custom-select-2
                v-if="entity.type && entity.type === 'test' && subscriptionForm.for_company"
                label="Тип теста"
                name="entity"
                v-model="entity.id"
                :options="testOptions"
            />

            <custom-select-2
                v-if="entity.type && entity.type === 'course' && subscriptionForm.for_company"
                label="Тип теста"
                name="entity"
                v-model="entity.id"
                :options="coursesOptions"
            />

            <custom-input
                v-if="entity.type && entity.type !== 'tracker' && entity.type !=='diary'"
                v-model="entity.count"
                type="number"
                name="count"
                :min="0"
                label="Количество"
            />
            <div class="remove_button">
              <button v-if="index !== 0" @click="removeField(index)" type='button' class="btn btn-xs btn-dark">
                Убрать
              </button>
            </div>
          </div>
          <div class="append_button">
            <button @click="addField" type='button' class="btn btn-xs btn-accent">
              Добавить новый продукт
            </button>
          </div>
          <div class="control_button">
            <button type="submit" class="btn btn-accent">
              Сохранить
            </button>
          </div>
        </form>
      </div>
      <div v-else class="table-preloader">
        <preloader/>
      </div>
    </div>

  </div>
</template>

<script>
import Preloader from "@/components/Technical/Preloader.vue";
import {onBeforeMount, ref} from "@vue/runtime-core";
import {computed, reactive} from "@vue/reactivity";
import CustomSelect2 from "@/components/Forms/Fields/CustomSelect2.vue";
import CustomInput from "@/components/Forms/Fields/CustomInput.vue";
import {useRoute, useRouter} from "vue-router";
import {useStore} from "vuex";
import useCheckRights from "@/mixins/useCheckRights";
import router from "../../router";
import CustomCheckbox from "@/components/Forms/Fields/CustomCheckbox.vue";
import {notify} from "@kyvg/vue3-notification";
import standartError from "@/mixins/standartError";
import useErrors from "@/mixins/useErrors";
import {
  getDefaultSubscriptionAnalyticsAccess,
  SUBSCRIPTION_ANALYTICS_ACCESS_OPTIONS,
} from "@/utils/subscriptionAnalyticsAccess";

export default {
  name: "SubscriptionForm.vue",
  methods: {
    router() {
      return router
    }
  },
  components: {CustomCheckbox, CustomInput, CustomSelect2, Preloader},
  setup() {
    const {setErrors, clearCustomErrors} = useErrors();
    const isLoaded = ref(true);
    const { getRight } = useCheckRights();
    const route = useRoute();
    const store = useStore();
    const subscription = computed(() => store.state.subscription.subscription)
    const subscriptionForm = reactive({
      title: '',
      description: '',
      duration_months: 0,
      price: 0,
      available: true,
      for_company: true,
      update_period: 'by_duration',
      analytics_access: getDefaultSubscriptionAnalyticsAccess(),
    });

    const analyticsAccessOptions = SUBSCRIPTION_ANALYTICS_ACCESS_OPTIONS;
    const updatePeriodOptions = [
      { id: 'monthly', text: 'Ежемесячно' },
      { id: 'by_duration', text: 'По истечению срока' },
    ];

    let products = reactive( [
      {
        id: null,
        title: '',
        type: '',
        count: 1,
        source: '',
      }
    ]);

    const types = [
      { id: 'course', text: 'Курс' },
      { id: 'test', text: 'Тест' },
      { id: 'reference_profile', text: 'Эталонный профиль' },
      { id: 'trajectory', text: 'Траектории'},
      { id: 'tracker', text: 'Навигатор эмоций'},
      { id: 'diary', text: 'Дневник Эмоций'},
    ];

    const entitiesOptions = computed(() => store.state.relations.entitiesList);
    const coursesOptions = computed(() => entitiesOptions.value.courses.map((course) => {
          return {
            id: course.id,
            text: course.title,
            source: course.source ?? null,
          }
        }
    ));
    const testOptions = computed(() => {
          let options = [];
          for (const [key, value] of Object.entries(entitiesOptions.value.tests)) {
            options.push(
                {
                  id: key,
                  text: value,
                }
            )
          }
          return options;
        }
    );

    const removeField = (index) => {
      products.splice(index, 1);
    }

    const addField = () => {
      products.push({
        id: null,
        title: '',
        type: '',
        count: 1,
        source: '',
      });
    }

    const saveSubscription = () => {

    if (!subscriptionForm.title || !subscriptionForm.duration_months) {
      notify({
        title: "Необходимо заполнить все поля",
        type: "error"
      });
      return;
    }

      let collectedProducts = products.filter((p) => p.type.length && p.count);

      if (!collectedProducts.length) {
        notify({
          title: "Необходимо добавить хотя бы один продукт",
          type: "error"
        });
        return;
      }

      const subscriptionProducts = [];

      collectedProducts.forEach((product) => {
        if ((product.type === 'course' || product.type === 'test') && !subscriptionForm.for_company) {
            notify({
              title: "Курсы и тесты можно добавлять только в подписку компаний",
              type: "error"
            });
            return;
        }

        let productObject = {
          type: product.type,
          count: product.count,
        }

        if (product.type === 'course') {
          if (!product.id) {
            notify({
              title: "Необходимо выбрать курс",
              type: "error"
            });
            return;
          }

          productObject.name = coursesOptions.value.find((course) => course.id === parseInt(product.id)).text;
          productObject.course_id = product.id;
          productObject.source = coursesOptions.value.find((course) => course.id === parseInt(product.id)).source;
        } else if (product.type === 'test') {
          if (!product.id) {
            notify({
              title: "Необходимо выбрать тип теста",
              type: "error"
            });

            return;
          }
          productObject.name = testOptions.value.find((test) => test.id === product.id).text;
          productObject.test_type = product.id;
        } else if (product.type === 'diary' || product.type === 'tracker') {
          let instrument = types.find((type) => type.id === product.type);
          productObject.name = instrument.text;
          productObject.type = product.type;
          productObject.count = 1;
        } else {
          productObject.name = types.find((type) => type.id === product.type).text;
        }

        subscriptionProducts.push(productObject);
      });

      if (subscriptionProducts.length < collectedProducts.length) {
        return;
      }

      const subscriptionObject = {
        title: subscriptionForm.title,
        description: subscriptionForm.description,
        duration_months: subscriptionForm.duration_months,
        price: subscriptionForm.price,
        available: !!subscriptionForm.available,
        for_company: subscriptionForm.for_company,
        update_period: subscriptionForm.update_period,
        analytics_access: { ...subscriptionForm.analytics_access },
        products: JSON.stringify(subscriptionProducts),
      }

      if (route.params.id) {
        subscriptionObject.id = route.params.id;
        store.dispatch("subscription/updateSubscription", subscriptionObject).then(() => {
          router.push('/subscription/list');
        }).catch(standartError(setErrors, clearCustomErrors));
      } else {
        store.dispatch("subscription/setSubscription", subscriptionObject).then(() => {
          router.push('/subscription/list');
        }).catch(standartError(setErrors, clearCustomErrors))
      }

    }

    onBeforeMount(() => {
      isLoaded.value = false;
      store.dispatch("profile/getProfile").then(() => {
        if (!getRight('superadmin')) {
          router.push('/');
        }
      });

      store.dispatch("relations/getEntitiesList").then(() => {
        if (route.params.id) {
          products.splice(0);
          store.dispatch('subscription/getSubscription', route.params.id).then(() => {
            isLoaded.value = false;
            subscriptionForm.title = subscription.value.title;
            subscriptionForm.description = subscription.value.description;
            subscriptionForm.duration_months = subscription.value.duration_months;
            subscriptionForm.price = subscription.value.price;
            subscriptionForm.for_company = subscription.value.for_company;
            subscriptionForm.available = !!subscription.value.available;
            subscriptionForm.update_period = subscription.value.update_period ?? 'by_duration';
            Object.assign(subscriptionForm.analytics_access, subscription.value.analytics_access);
            subscription.value.products.forEach((product) => {
              products.push({
                id: product.test_type ?? product.course_id,
                type: product.type,
                title: product.title,
                count: product.count,
                source: product.source ?? null,
              })
            });
            isLoaded.value = true;
          });
        } else {
          isLoaded.value = true;
        }
      });
    });

    return {
      route,
      isLoaded,
      subscriptionForm,
      types,
      products,
      testOptions,
      coursesOptions,
      analyticsAccessOptions,
      updatePeriodOptions,
      removeField,
      addField,
      saveSubscription
    }
  }
}
</script>

<style scoped lang="scss">
  .available_checkbox,
  .company_checkbox,
  .analytics_access,
  .remove_button {
    padding-left: 10px;
  }

  .analytics_access {
    margin-top: 10px;
  }

  .analytics_access__title {
    margin-bottom: 4px;
    font-weight: 600;
  }

  .subscription_form {
    display: flex;
    flex-direction: column;
    row-gap: 15px;
  }
  .control_button {
    margin-left: auto;
  }

  .append_button {
    margin-left: auto;
  }

  .instruments_title {
    margin-bottom: 35px;
  }

  @media (max-width: 910px) {
    .available_checkbox,
    .company_checkbox,
    .analytics_access,
    .remove_button {
      padding-left: 0;
    }
  }
</style>
